import type { ChatMessage } from '@/types'

export type DiscourseSupportNote = {
  content: string
  messageId?: string | null
}

/**
 * Append a proactive support note from the graph as an agent message.
 *
 * Notes arrive on the persistent connection without a turn of their own, so they
 * are plain messages keyed by the persisted server message id (redelivery and
 * thread-history reload must not duplicate them).
 */
export function appendDiscourseSupportNote(
  messages: ChatMessage[],
  note: DiscourseSupportNote,
  fallbackId: () => string,
): ChatMessage[] {
  const content = (note.content || '').trim()
  if (!content) return messages

  const serverMessageId = note.messageId ? String(note.messageId) : ''
  if (serverMessageId && messages.some((m) => m.serverMessageId === serverMessageId)) {
    return messages
  }

  return [
    ...messages,
    {
      id: serverMessageId || fallbackId(),
      content,
      isUser: false,
      messageType: 'discourse_support',
      serverMessageId: serverMessageId || undefined,
      createdAt: Date.now(),
    } as ChatMessage,
  ]
}
